export default __webpack_public_path__ + "80dc643a40470d84c8d45b3e4cbea0f3.png";